/**
 * @generated SignedSource<<e9f1d625d7249ac2074ab45ea5274f86>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useNavSettingsService$data = {
  readonly properties: {
    readonly nodes: ReadonlyArray<{
      readonly key: string | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly sidebar: {
    readonly nodes: ReadonlyArray<{
      readonly menuId: string | null;
      readonly visible: boolean | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "useNavSettingsService";
};
export type useNavSettingsService$key = {
  readonly " $data"?: useNavSettingsService$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useNavSettingsService",
  "selections": [
    {
      "args": (v0/*: any*/),
      "concreteType": "SettingsMenuItemConnection",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "menuId"
            },
            {
              "kind": "ScalarField",
              "name": "visible"
            }
          ]
        }
      ],
      "storageKey": "sidebar(first:100)"
    },
    {
      "args": (v0/*: any*/),
      "concreteType": "SettingsDisplayPropertyConnection",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsDisplayProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ],
      "storageKey": "properties(first:100)"
    }
  ],
  "type": "SettingsNavigationCustomisation"
};
})();

(node as any).hash = "7dd831db0a931af821f9ef85c93e4aac";

export default node;
